<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			projectName: 'Ostrowski ortopeda',
			author: 'yurczak.com',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light"
		>
			&copy; 2022 - {{ copyrightDate }}.
			<a
				href="http://ostrowskiortopeda.pl"
				target="__blank"
				class="font-general-medium hover:underline hover:text-green-600 dark:hover:text-green-300 duration-500"
			>
				{{ projectName }}
			</a>
			. Developed by
			<a
				href="https://yurczak.com"
				target="__blank"
				class="font-general-medium text-secondary-dark dark:text-secondary-light hover:underline hover:text-green-600 dark:hover:text-green-300 duration-500"
				>{{ author }}</a
			>
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
